<template>
    <ReportAccident></ReportAccident>
</template>

<script>
import ReportAccident from "../../components/Safety/ReportAccident.vue";
import AuthLayout from "../../Layouts/AuthLayout.vue";

export default {
    name: "Safety_ReportAccident",
    components: { ReportAccident, AuthLayout },
};
</script>